var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.582,
    height: 43.582,
    viewBox: "0 0 43.582 43.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:none;stroke:#157dc3;stroke-linecap:round;stroke-width:2px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_672",
    transform: "translate(-498.58 -68.081) rotate(-45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_635",
    transform: "translate(289 416.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_266",
    fill: "#fff",
    d: "M15.409 0A15.409 15.409 0 1 1 0 15.409 15.409 15.409 0 0 1 15.409 0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_272",
    d: "M697.72 7416.5h15.9",
    className: "cls-2",
    transform: "translate(-401.287 -6984.993)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_273",
    d: "M0 0h15.9",
    className: "cls-2",
    transform: "translate(304.387 439.46) rotate(-90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.02e83550.svg";
export { ForwardRef as ReactComponent };